export default __webpack_public_path__ + "static/1-1987685729b38881f5b47f27166c1dec.svg";